module.exports = __webpack_public_path__ + "vi.9b32e9eaa86eef7a0d13.svg";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/scss/icons/flag-icon-css/flags/vi.svg
// module id = ../../../../../src/assets/scss/icons/flag-icon-css/flags/vi.svg
// module chunks = styles